import { IonicErrorHandler } from 'ionic-angular';
import Raven from 'raven-js';
import {CART} from '../providers/data';
import {Constants} from '../providers/config';


if(Constants.isWebstore){
Raven
    .config(Constants.iCommSentryToken)
    .install();
}else{
    Raven
    .config(Constants.iRepSentryToken)
    .install();
}




    Raven.setRelease(Constants.appVersion+"-"+Constants.webstoreVersion);
export class SentryErrorHandler extends IonicErrorHandler {



    handleError(error) {
        try {
        console.log("User: ",CART.user.userName);
        console.log("::<==>:: id : ",CART.user.id);
        console.log("::<==>:: FirstName : ", CART.user.firstName);
        console.error(error);
          Raven.captureException(error.originalError || error);
          Raven.setTagsContext({ user: CART.user.userName });
          Raven.setUserContext({username:CART.user.userName});
        }
        catch(e) {

        console.log("User: ",CART.user.userName);
        console.log("::<==>:: id : ",CART.user.id);
        console.log("::<==>:: FirstName : ", CART.user.firstName);
          console.error(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/sentry-error-handler.ts